import { INIT_LANGUAGES } from "../types";
import { styleAlphabet } from "../../assets/alphabet/alphabet";
import { ukraineAlphabet } from "../../constants/ukraine/ukraineAlphabet";
import { frenchAlphabet } from '../../constants/french/frenchAlphabet'; 

export const init = () => {
  return {
    type: INIT_LANGUAGES,
    payload: {
      english: styleAlphabet,
      ukraine: ukraineAlphabet,
      french: frenchAlphabet,
    },
  };
};
